import DirectDepositSetupPageContent from 'features/directDeposit/screens/DirectDepositSetupPageContent';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function DirectDepositSetupPage() {
  return (
    <PinwheelContextProvider>
      <DirectDepositSetupPageContent />
    </PinwheelContextProvider>
  );
}
